import { Link } from '@tanstack/react-router'

export function Footer() {
  return (
    <footer className="mt-auto border-t border-line py-6 text-sm text-ink-muted">
      <div className="mx-auto flex w-full max-w-[1440px] flex-col items-center justify-between gap-4 px-4 sm:flex-row sm:px-6 lg:px-8">
        <p>© 2026 Govind Barde</p>
        <div className="flex items-center gap-6">
          <a
            href="https://docs.github.com"
            target="_blank"
            rel="noreferrer"
            className="transition-colors hover:text-primary"
          >
            Docs
          </a>
          <Link to="/privacy" className="transition-colors hover:text-primary">
            Privacy
          </Link>
          <Link to="/terms" className="transition-colors hover:text-primary">
            Terms
          </Link>
          <a
            href="https://github.com"
            target="_blank"
            rel="noreferrer"
            className="transition-colors hover:text-primary"
          >
            GitHub
          </a>
        </div>
      </div>
    </footer>
  )
}
